import { createAction, props } from '@ngrx/store';
import { PotentialConsequence } from '../../models/potential-consequence.model';
import { UpdatePotentialConsequenceRequest } from '../../models/requests/update-potential-consequence-request';
import { CreatePotentialConsequenceRequest } from '../../models/requests/create-potential-consequence-request';


// Load actions
export const loadPotentialConsequences = createAction(
  '[potentialConsequence] Load Potential Consequence',
  props<{ ruleUid: string | undefined }>()
);
export const loadPotentialConsequencesSuccess = createAction(
  '[potentialConsequence] Load Potential Consequence Success',
  props<{ potentialConsequences: PotentialConsequence[] }>()
);
export const loadPotentialConsequencesFailure = createAction(
  '[potentialConsequence] Load Potential Consequence Failure',
  props<{ error: any }>()
);

// Delete actions
export const deleteMultiplePotentialConsequences = createAction(
  '[potentialConsequence] Delete Multiple Potential Consequences',
  props<{ uids: string[] }>()
);
export const deleteMultiplePotentialConsequencesSuccess = createAction(
  '[potentialConsequence] Delete Multiple Potential Consequences Success',
  props<{ uids: string[] }>()
);
export const deleteMultiplePotentialConsequencesFailure = createAction(
  '[potentialConsequence] Delete Multiple Potential Consequences Failure',
  props<{ error: any }>()
);

export const createMultiplePotentialConsequences = createAction(
  '[potentialConsequence] Create Multiple Potential Consequences',
  props<{ requests: CreatePotentialConsequenceRequest[] }>()
);
export const createMultiplePotentialConsequencesSuccess = createAction(
  '[potentialConsequence] Create Multiple Potential Consequences Success',
  props<{ potentialConsequences: PotentialConsequence[] }>()
);
export const createMultiplePotentialConsequencesFailure = createAction(
  '[potentialConsequence] Create Multiple Potential Consequences Failure',
  props<{ error: any }>()
);

export const updateMultiplePotentialConsequences = createAction(
  '[potentialConsequence] Update Multiple Potential Consequences',
  props<{ requests: UpdatePotentialConsequenceRequest[] }>()
);
export const updateMultiplePotentialConsequencesSuccess = createAction(
  '[potentialConsequence] Update Multiple Potential Consequences Success',
  props<{ potentialConsequences: PotentialConsequence[] }>()
);
export const updateMultiplePotentialConsequencesFailure = createAction(
  '[potentialConsequence] Update Multiple Potential Consequence Failure',
  props<{ error: any }>()
);
